import { create } from 'zustand';

type Theme = 'dark' | 'light';
const STORAGE_KEY = 'hartos.theme';

function initialTheme(): Theme {
  // Dark by default: this screen is watched for long stretches, often in a room
  // where a bright panel is the wrong thing to stare at.
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    /* storage unavailable (private mode); fall through to the default */
  }
  return 'dark';
}

interface UiState {
  theme: Theme;
  toggleTheme: () => void;
  applyTheme: () => void;
}

export const useUi = create<UiState>((set, get) => ({
  theme: initialTheme(),
  toggleTheme() {
    const theme = get().theme === 'dark' ? 'light' : 'dark';
    set({ theme });
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* ignore */
    }
    document.documentElement.dataset.theme = theme;
  },
  applyTheme() {
    document.documentElement.dataset.theme = get().theme;
  },
}));
